import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
  }, []);

  useEffect(() => {
    if (!settings) return;
    if (settings.google_analytics_id) {
      const s = document.createElement("script");
      s.src = `https://www.googletagmanager.com/gtag/js?id=${settings.google_analytics_id}`;
      s.async = true;
      document.head.appendChild(s);
    }
  }, [settings]);

  return <SiteContext.Provider value={{ settings: settings || {} }}>{children}</SiteContext.Provider>;
}
